<ui-app #uiApp>
  <router-outlet></router-outlet>

  <ui-snackbar #snackbar></ui-snackbar>
</ui-app>
